import React from 'react';
import { Container } from 'react-bootstrap';
import Footer from '../components/Footer';
import ReactGA from 'react-ga4';

const EV_FLEETS_URL = 'https://yas.io/en/solutions/ev-fleets';

const SIGNAL_ITEMS = [
  {
    label: 'YAS AURA',
    description: 'Explainable scores built from live driving data.',
  },
  {
    label: 'EV & Commercial Fleets',
    description: 'Fleet-level evidence across trips, drivers, vehicles, and exposure.',
  },
  {
    label: 'Insurer-Ready Records',
    description: 'Behaviour and road context organised for licensed insurer partners.',
  },
];

const trackCta = (label) => {
  ReactGA.event({
    category: 'Sunset',
    action: 'click',
    label,
  });
};

const Homepage = () => {
  return (
    <div className="sunset-page">
      <main className="sunset-main">
        <Container className="sunset-container">
          <section className="sunset-shell" aria-labelledby="sunset-title">
            <div className="sunset-copy">
              <p className="sunset-eyebrow">
                <span aria-hidden="true" />
                YASMO product update
              </p>
              <h1 id="sunset-title" className="sunset-headline">
                From your Virtual Smart Traffic Assistant to fleet risk intelligence.
              </h1>
              <p className="sunset-lead">
                YASMO helped people understand mobility risk in everyday journeys. YAS is now
                carrying that work forward for commercial fleets, where live driving data can
                support safer operations and more responsive protection.
              </p>
              <p className="sunset-body">
                The YASMO consumer app is no longer available for new users. Its scoring
                foundation now supports AURA and our EV &amp; Commercial Fleets platform, helping
                fleet operators and insurer partners turn driving behaviour and road context into
                explainable scores.
              </p>

              <a
                className="sunset-btn sunset-btn-primary"
                href={EV_FLEETS_URL}
                onClick={() => trackCta('continue-ev-fleets')}
              >
                Continue to EV &amp; Commercial Fleets
              </a>
            </div>

            <aside className="sunset-panel" aria-label="Technology now powers">
              <p className="sunset-panel-kicker">Technology now powers</p>
              <ul className="sunset-signal-list">
                {SIGNAL_ITEMS.map((item) => (
                  <li key={item.label}>
                    <span>{item.label}</span>
                    <p>{item.description}</p>
                  </li>
                ))}
              </ul>
            </aside>
          </section>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default Homepage;
